var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{staticClass:"form-text text-danger"},[_c('img',{attrs:{"src":require("../assets/img/red_error_msg.svg")}}),_vm._v(_vm._s(_vm.message)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }